define('components/boilerplate/models/base',[
    'components/utils/models/guid'
], function (Guid) {
    "use strict";

    return Backbone.Model.extend({
        "authoringJSONKey": null,

        "saveStateJSONKey": null,

        "idAttribute": "_id",

        "url": null,

        "complexRelations": function () {
            return [
                {
                    "attr": "_id",
                    "fn": function (value) {
                        var guid = value && value.toLowerCase() || null;
                        this.set('guid', guid || Guid.generate());
                        return guid;
                    }
                }
            ];
        },

        "defaults": function () {
            return {
                "_id": null
            };
        },

        "set": function (attr, value) {
            var complexRelations = this.complexRelations();

            if (attr instanceof Object) {
                attr = _.extend({}, attr);
            }

            _.each(complexRelations, function (relation) {
                var curValue;

                if (relation.attr === attr) {
                    // When >> model.set(attr, value)
                    if (relation.fn) {
                        value = relation.fn.call(this, value);
                    } else if (relation.Class &&
                               (value === void 0 || value === null || value.constructor !== relation.Class)) {
                        value = new relation.Class(value);
                    }
                } else if (attr instanceof Object
                           && relation.attr in attr) {
                    // When >> model.set({ attr: value })
                    curValue = attr[relation.attr];

                    if (relation.fn) {
                        curValue = relation.fn.call(this, curValue);
                    } else if (relation.Class &&
                                (curValue === void 0 || curValue === null || curValue.constructor !== relation.Class)) {
                        curValue = new relation.Class(curValue);
                    }

                    attr[relation.attr] = curValue;
                }
            }, this);

            return Backbone.Model.prototype.set.call(this, attr, value);
        },

        "update": function (data) {
            _.each(data, function (newValue, key, origData) {
                var origValue = this.get(key);

                if (_.isFunction(origValue && origValue.update)) {
                    origValue.update(newValue);
                    return;
                }

                if (_.isObject(newValue)) {
                    $.extend(true, origValue, newValue);
                    return;
                }

                this.set(key, newValue);
            }, this);
        },

        "toJSON": function () {
            var jsonData = Backbone.Model.prototype.toJSON.call(this),
                complexRelations = this.complexRelations();

            _.each(complexRelations, function (relation) {
                var value = this.get(relation.attr);

                if (value && value.toJSON) {
                    jsonData[relation.attr] = value.toJSON();
                }
            }, this);

            return jsonData;
        },

        "toAuthoringJSON": function (withChildren) {
            var modelJSON,
                childrenAttribute,
                authoringJSONKey = this.authoringJSONKey && this.authoringJSONKey();

            if (!authoringJSONKey) {
                modelJSON = this.toJSON();
                return modelJSON;
            }

            withChildren = !!withChildren;
            childrenAttribute = this.childrenAttribute;

            modelJSON = this.filterJSON({
                "filterKey": authoringJSONKey,
                "withChildren": withChildren,
                "childrenAttribute": childrenAttribute,
                "dataMethod": "toAuthoringJSON"
            });

            return modelJSON;
        },

        "filterJSON": function (opts) {
            var filteredJSON = {},
                isJSON,
                withChildren,
                childrenAttribute;

            opts = opts || {};

            opts.target = opts.target || this;
            opts.filterKey = opts.filterKey || null;
            isJSON = !!opts.isJSON;
            withChildren = !!opts.withChildren;
            childrenAttribute = opts.childrenAttribute || null;

            _.each(opts.filterKey, function (value, key) {
                var targetVal = isJSON ? opts.target[key] : opts.target.get(key),
                    dataMethod = null;

                if (!(isJSON || withChildren
                    || !childrenAttribute || key !== childrenAttribute)) {
                    return;
                }

                if (opts.dataMethod && targetVal) {
                    if (_.isString(opts.dataMethod) && targetVal[opts.dataMethod]) {
                        // dataMethod is a string and the key exists in targetVal
                        dataMethod = targetVal[opts.dataMethod];
                    } else if (_.isFunction(opts.dataMethod)) {
                        // dataMethod is a function
                        dataMethod = opts.dataMethod;
                    }
                }

                targetVal = targetVal && (dataMethod && dataMethod.call(targetVal, withChildren) ||
                            targetVal.toJSON && targetVal.toJSON() ||
                            targetVal);

                if (targetVal === void 0) {
                    return;
                }

                if (value && targetVal) {
                    filteredJSON[key] = this.filterJSON({
                        "target": targetVal,
                        "filterKey": value,
                        "isJSON": true
                    });
                    return;
                }

                filteredJSON[key] = targetVal;

            }, this);

            return filteredJSON;
        },

        "fetch": function () {
            var fetchOpts = this.getRequestOptions('fetch'),
                xhr;

            xhr = Backbone.Model.prototype.fetch.call(this, fetchOpts);

            this.trigger('fetch', this, xhr);

            return xhr;
        },

        "childrenAttribute": null,

        "parse": function (response) {
            if (this.childrenAttribute) {
                response[this.childrenAttribute] = response.children;
                delete response.children;
            }

            return response;
        },

        "fetchList": function () {
            var fetchOpts = this.getRequestOptions('list'),
                xhr;

            xhr = Backbone.Model.prototype.fetch.call(this, fetchOpts);

            this.trigger('fetch', this, xhr);

            return xhr;
        },

        "save": function () {
            var modelId = this.get('_id'),
                requestOptions = this.getRequestOptions(modelId ? 'update' : 'create'),
                xhr;

            xhr = $.ajax(requestOptions).done(function (response) {
                this.set(response);
                this.trigger('sync', this);
            });

            return xhr;
        },

        "saveChildOrder": function (opts) {
            var requestOptions,
                xhr;

            opts = opts || {};

            if (!opts.childIds) {
                return false;
            }

            requestOptions = this.getRequestOptions('updateChildOrder', opts);

            xhr = $.ajax(requestOptions).done(function (response) {
                var childCollection;

                if (this.childrenAttribute) {
                    childCollection = this.get(this.childrenAttribute);

                    _.each(opts.childIds, function (childId, index) {
                        var child = childCollection.findWhere({
                            "_id": childId
                        });

                        if (!child) {
                            return;
                        }

                        childCollection.remove(child);
                        childCollection.add(child, {
                            "at": index
                        });
                    });
                }

                this.trigger('sync', this);
            });

            return xhr;
        },

        "saveState": function () {
            return $.ajax(
                            this.getRequestOptions('save-state')
                        )
                        .done(function (response) {
                            this.trigger('save-state:success');
                            this.trigger('sync', this);
                        })
                        .fail(function () {
                            this.trigger('save-state:error');
                        });
        },

        "retrieveState": function () {
            var requestOptions = this.getRequestOptions('retrieve-save-state'),
                xhr;

            xhr = $.ajax(requestOptions).done(function (response) {
                this.update(response);
                this.trigger('sync', this);
            }).fail(function (jqXHR) {
                if (jqXHR.status === 404) {
                    this.trigger('sync', this);
                }
            });

            return xhr;
        },

        "destroy": function () {
            var requestOptions = this.getRequestOptions('delete'),
                xhr;

            xhr = $.ajax(requestOptions).done(function (response) {
                this.trigger('sync', this);
            });

            this.trigger('destroy', this);

            return xhr;
        },

        "getRequestOptions": function (requestType, opts) {
            var requestOptions = _.extend({
                    "contentType": "application/json",
                    "context": this,
                    "data": null,
                    "dataType": "json",
                    "xhrFields": {
                        "withCredentials": true
                    }
                }, opts),
                modelId = this.get('_id'),
                modelVersion = this.get('version') || 1,
                encodedModelId = modelId ? window.encodeURIComponent(modelId) : '',
                url = this.url || null,
                methodParams,
                tempData;

            requestOptions.data = requestOptions.data || {};

            if (this.urls) {
                if (window.initData.isEditorial) {
                    url = this.urls.editorial || null;
                } else {
                    url = this.urls.runtime || this.urls.editorial || null;
                }
            }

            switch (requestType) {
                case 'create':
                    methodParams = {
                        "type": "POST",
                        "url": url + "?method=create",
                        "data": JSON.stringify(this.toAuthoringJSON()),
                        "processData": false
                    };

                    break;

                case 'delete':
                    methodParams = {
                        "type": "POST",
                        "url": url + "?method=delete&_id=" + encodedModelId
                    };

                    break;

                case 'fetch':
                    methodParams = {
                        "contentType": "application/x-www-form-urlencoded",
                        "type": "GET",
                        "url": url + "?method=get&_id=" + encodedModelId
                    };

                    if (!this.urls) {
                        break;
                    }

                    if (!window.initData.isEditorial) {
                        methodParams.url = this.urls.runtime + "?id=" + encodedModelId;
                    }

                    break;

                case 'list':
                    methodParams = {
                        "type": "GET",
                        "url": url + "?method=list"
                    };

                    break;

                case 'update':
                    methodParams = {
                        "type": "POST",
                        "url": url + "?method=update&_id=" + encodedModelId,
                        "data": JSON.stringify(this.toAuthoringJSON()),
                        "processData": false
                    };

                    break;

                case 'updateChildOrder':
                    methodParams = {
                        "type": "POST",
                        "url": url + "?method=update&_id=" + encodedModelId,
                        "data": JSON.stringify({
                            "_id": modelId,
                            "childIds": opts.childIds
                        }),
                        "processData": false
                    };
                    break;

                case 'save-state':
                    tempData = this.getSaveStateJSON();
                    tempData.module_id = modelId;
                    tempData.version = modelVersion;

                    methodParams = {
                        "type": "PUT",
                        "url": this.urls.saveState,
                        "data": JSON.stringify(tempData),
                        "processData": false,
                        "headers": {
                            "X-Requested-With": "XMLHttpRequest"
                        }
                    };

                    break;

                case 'retrieve-save-state':
                    methodParams = {
                        "type": "GET",
                        "url": this.urls.saveState + '/' + modelId + '/' + modelVersion,
                        "headers": {
                            "X-Requested-With": "XMLHttpRequest"
                        }
                    };

                    break;
            }

            return _.extend(requestOptions, methodParams);
        },

        "getSaveStateJSON": function () {
            var saveStateJSON,
                childrenAttribute,
                saveStateJSONKey = this.saveStateJSONKey && this.saveStateJSONKey();

            if (!saveStateJSONKey) {
                saveStateJSON = this.toJSON();
                return saveStateJSON;
            }

            childrenAttribute = this.childrenAttribute;

            saveStateJSON = this.filterJSON({
                "filterKey": saveStateJSONKey,
                "withChildren": true,
                "childrenAttribute": childrenAttribute,
                "dataMethod": "getSaveStateJSON"
            });

            return saveStateJSON;
        }
    });
});

